import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssignmentGroupInteractionService } from '../services/assignment-group-interaction.service';
import { AssignmentGroupDetails } from '../models/assignment-group-details';

@Component({
  selector: 'app-create-assignment-group-slider',
  templateUrl: './create-assignment-group-slider.component.html',
  styleUrls: ['./create-assignment-group-slider.component.scss']
})
export class CreateAssignmentGroupSliderComponent implements OnInit {
  @Input() isAssignmentGroupSliderOpen = false;
  @Input() get assignmentGroupToEdit(): any {
    return this._assignmentGroupToEdit;
  }
  set assignmentGroupToEdit(val: AssignmentGroupDetails) {
    if (val) {
      this._assignmentGroupToEdit = val;
      this.setDetailsForEdit();
    }
  }

  @Output() isAssignmentGroupSliderActive = new EventEmitter<boolean>();
  private _assignmentGroupToEdit!: AssignmentGroupDetails;
  topBarTitle = 'Create Assignment Group';

  constructor(private assignmentGroupInteractionService: AssignmentGroupInteractionService) { }

  ngOnInit(): void {
    this.assignmentGroupInteractionService.closeAndResetAssignmentGroupSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetAssignmentGroupSlider(); }
    })
  }
  setDetailsForEdit = () => {
    this.topBarTitle = 'Edit Assignment Group';
  }
  closeSlider() {
    this.assignmentGroupInteractionService.openConfirmationDialog();
  }

  closeAndResetAssignmentGroupSlider() {
    this.isAssignmentGroupSliderOpen = false;
    this.isAssignmentGroupSliderActive.emit(this.isAssignmentGroupSliderOpen);
  }
}
